(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*! js-cookie v3.0.5 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  })());
})(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (name, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      name = encodeURIComponent(name)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        name + '=' + converter.write(value, name) + stringifiedAttributes)
    }

    function get (name) {
      if (typeof document === 'undefined' || (arguments.length && !name)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var found = decodeURIComponent(parts[0]);
          jar[found] = converter.read(value, found);

          if (name === found) {
            break
          }
        } catch (e) {}
      }

      return name ? jar[name] : jar
    }

    return Object.create(
      {
        set,
        get,
        remove: function (name, attributes) {
          set(
            name,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

}));

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableGA = disableGA;
exports.enableGA = enableGA;
exports.initGA = initGA;
exports.track = track;
var _localStorageService = require("./local-storage-service");
var ANALYTICS_CONENT_KEY = 'ANALYTICS_ACCEPTED';
function isGAEnabled() {
  return (0, _localStorageService.getItem)(ANALYTICS_CONENT_KEY) === 'true' ? true : false;
}
function disableGA() {
  (0, _localStorageService.removeItem)(ANALYTICS_CONENT_KEY);
  window.location.reload();
}
function enableGA() {
  (0, _localStorageService.setItem)(ANALYTICS_CONENT_KEY, 'true');
  window.location.reload();
}
function track(eventName, value) {
  var isEnabled = isGAEnabled();
  if (isEnabled === true) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      value: value
    });
    // return googleAnalyticsClient().track(eventName, payload, options, callback);
  }
}
function initGA() {
  var isEnabled = isGAEnabled();
  if (isEnabled === true) {
    var gtmKey = document.getElementById('gtmKey');
    if (gtmKey && gtmKey.value) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', gtmKey.value);
    }
  }
}

},{"./local-storage-service":5}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showHideMessageBanner = exports.hideHideMessageBanner = exports.hideAcceptRejectAndMessage = void 0;
var _analyticsHelpers = require("./analytics-helpers");
var _cookiesHelpers = require("./cookies-helpers");
var _localStorageService = require("./local-storage-service");
var setShowHideButton = function setShowHideButton(value) {
  (0, _localStorageService.setItem)('showHideButton', value);
};
var getShowHideButton = function getShowHideButton() {
  return (0, _localStorageService.getItem)('showHideButton');
};
var hideAcceptRejectAndMessage = exports.hideAcceptRejectAndMessage = function hideAcceptRejectAndMessage() {
  var gaAcceptButtons = document.querySelectorAll('.ga-cookies-button-accept');
  var gaRejectButtons = document.querySelectorAll('.ga-cookies-button-reject');
  var questionBanner = document.querySelector('.js-question-banner');
  gaAcceptButtons.forEach(function (btn) {
    return btn.style.display = 'none';
  });
  gaRejectButtons.forEach(function (btn) {
    return btn.style.display = 'none';
  });
  if (questionBanner) {
    questionBanner.style.display = 'none';
  }
};
var hideHideMessageBanner = exports.hideHideMessageBanner = function hideHideMessageBanner() {
  var cookieBanner = document.querySelector('.js-cookies-banner');
  if (cookieBanner) cookieBanner.setAttribute('hidden', 'hidden');
};
var showHideMessageBanner = exports.showHideMessageBanner = function showHideMessageBanner() {
  var hideBannerFunction = function hideBannerFunction() {
    var cookieBanner = document.querySelector('.js-cookies-banner');
    var hideButton = document.querySelector('.js-cookies-hide');
    setShowHideButton('false');
    if (cookieBanner) {
      cookieBanner.setAttribute('hidden', 'hidden');
    }
    if (hideButton) {
      hideButton.setAttribute('hidden', 'hidden');
    }
  };
  var banner = document.querySelector('.js-cookies-hide');
  if (!banner) return;
  banner.removeAttribute('hidden');
  banner.setAttribute('tabindex', '-1');
  banner.focus();
  hideAcceptRejectAndMessage();
  var hideButton = banner.querySelector('.js-hide');
  if (hideButton) {
    hideButton.style.display = 'block';
    hideButton.removeAttribute('hidden');
    hideButton.addEventListener('click', hideBannerFunction);
  }
};
(function () {
  var gaAcceptButtons = document.querySelectorAll('.ga-cookies-button-accept');
  var gaRejectButtons = document.querySelectorAll('.ga-cookies-button-reject');
  gaAcceptButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      (0, _analyticsHelpers.enableGA)();
      (0, _cookiesHelpers.acceptCookies)();
      setShowHideButton('true');
    });
  });
  gaRejectButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      (0, _analyticsHelpers.disableGA)();
      (0, _cookiesHelpers.rejectCookies)();
      setShowHideButton('true');
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    var cookiePreference = (0, _cookiesHelpers.getCookies)();
    if (cookiePreference) {
      var showHideButtonValue = getShowHideButton();
      if (showHideButtonValue === 'true') {
        showHideMessageBanner();
      } else {
        hideHideMessageBanner();
      }
    } else {
      var cookieBanner = document.querySelector('.js-cookies-banner');
      if (cookieBanner) cookieBanner.removeAttribute('hidden');
    }
  });
})();

},{"./analytics-helpers":2,"./cookies-helpers":4,"./local-storage-service":5}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rejectCookies = exports.getCookies = exports.acceptCookies = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// cookieHelpers.js

var cookieKey = 'ddtpCookie';
var acceptCookies = exports.acceptCookies = function acceptCookies() {
  return _jsCookie["default"].set(cookieKey, 'accepted', {
    expires: 360
  });
};
var rejectCookies = exports.rejectCookies = function rejectCookies() {
  return _jsCookie["default"].set(cookieKey, 'rejected', {
    expires: 360
  });
};
var getCookies = exports.getCookies = function getCookies() {
  return _jsCookie["default"].get(cookieKey);
};

},{"js-cookie":1}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = exports.removeItem = exports.getItem = exports.clear = void 0;
var clear = exports.clear = function clear() {
  if (typeof window !== 'undefined') {
    localStorage.clear();
  }
};
var getItem = exports.getItem = function getItem(key) {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(key);
  }
};
var removeItem = exports.removeItem = function removeItem(key) {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(key);
  }
};
var setItem = exports.setItem = function setItem(key, value) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, value);
  }
};

},{}]},{},[3]);
